<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="userId" >
                        <span slot="label" ><a-tooltip>{{$t('电子集卡盖章记录.用户id')}}<template slot="title">{{$t('电子集卡盖章记录.用户id')}}</template></a-tooltip> </span>
                        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+'用户id'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['userId']"
                              input-type="input"
                              table-name="zb_dianzi_jika"
                              table-field="userId"
                              :field-value="form.userId"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="num" >
                        <span slot="label" ><a-tooltip>{{$t('电子集卡盖章记录.集卡数(5个兑换一次游戏币，10个兑换一次游戏币并结算记录)')}}<template slot="title">{{$t('电子集卡盖章记录.集卡数(5个兑换一次游戏币，10个兑换一次游戏币并结算记录)')}}</template></a-tooltip> </span>
                        <a-input v-model="form.num"  :placeholder="$t('通用.输入.请输入')+'集卡数(5个兑换一次游戏币，10个兑换一次游戏币并结算记录)'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['num']"
                              input-type="input"
                              table-name="zb_dianzi_jika"
                              table-field="num"
                              :field-value="form.num"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="isJiesuan" >
                        <span slot="label" ><a-tooltip>{{$t('电子集卡盖章记录.0,未结算 1,已结算')}}<template slot="title">{{$t('电子集卡盖章记录.0,未结算 1,已结算')}}</template></a-tooltip> </span>
                        <a-input v-model="form.isJiesuan"  :placeholder="$t('通用.输入.请输入')+'0,未结算 1,已结算'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['isJiesuan']"
                              input-type="input"
                              table-name="zb_dianzi_jika"
                              table-field="isJiesuan"
                              :field-value="form.isJiesuan"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="picture" >
                        <span slot="label" ><a-tooltip>{{$t('电子集卡盖章记录.电子卡片图片')}}<template slot="title">{{$t('电子集卡盖章记录.电子卡片图片')}}</template></a-tooltip> </span>
                        <a-input v-model="form.picture" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getDianziJika, addDianziJika, updateDianziJika } from '@/api/dianziJika/dianziJika'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          userId: null,
                          num: null,
                          isJiesuan: null,
                          picture: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              userId: [{ required: true, message: this.$t('电子集卡盖章记录.用户id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          userId: null,
                          num: null,
                          isJiesuan: null,
                          picture: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDianziJika({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateDianziJika(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addDianziJika(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
